import 'isomorphic-fetch';
import React, { useContext } from 'react';
import { ThemeProvider } from '@chakra-ui/core';
import { ApolloProvider } from '@apollo/client';

import { GlobalSpinner } from './src/components/GlobalSpinner';
import { useLanguage, LanguageContextProvider } from './src/contexts/LanguageContext';
import { SpinnerContextProvider } from './src/contexts/SpinnerContext';
import './src/css/style.css';
import { dkkClient, eurClient } from './src/client';

const ApolloClient = ({ children }) => {
  const { currency } = useLanguage();

  return <ApolloProvider client={currency === 'DKK' ? dkkClient : eurClient}>{children}</ApolloProvider>;
};

export const wrapRootElement = ({ element }) => {
  return (
    <LanguageContextProvider>
      <ApolloClient>
        <SpinnerContextProvider>
          <ThemeProvider>
            <GlobalSpinner />
            {element}
          </ThemeProvider>
        </SpinnerContextProvider>
      </ApolloClient>
    </LanguageContextProvider>
  );
};
